import { React, useState, useEffect, useCallback, observer, useTranslation, css, main } from '../..';
import { ToggleContainer, InputLabel, Input, TextArea, Message } from '@weezevent/nacre';
import { isUrl } from '../../utils';

const EmailToggle = observer(() => {
    const { emailToggle, premiumOptions, event, messageIsValid, language } = main;

    const { t } = useTranslation();
    const [checked, setChecked] = useState(true);
    const [subject, setSubject] = useState(t('attendees.invitations.message.subject', { eventTitle: event.name, lng: language }));
    const [message, setMessage] = useState(t('attendees.invitations.message.body', { eventTitle: event.name, lng: language }));
    const [valid, setValid] = useState(true);

    const handleToggle = useCallback(
        (e, value) => {
            setChecked(value.checked);
            main.setEmailToggle(value.checked);
        },
        [main, setChecked]
    );

    const handleObject = useCallback(
        e => {
            if (e.target.value === '' || null) {
                setSubject(null);
                main.setSubject('');
            }
            setSubject(e.target.value);
            main.setSubject(e.target.value);
        },
        [main, setSubject]
    );

    const handleMessage = useCallback(
        e => {
            let value = e.target.value;
            if (value === '' || null) {
                setMessage(null);
                main.setMessage('');
            }
            if (!premiumOptions) {
                let words = value.split(/\s+/);
                if (words.some(w => isUrl(w))) {
                    setValid(false);
                    main.setMessageValidity(false);
                } else {
                    setValid(true);
                    main.setMessageValidity(true);
                }
            }
            setMessage(value);
            main.setMessage(value);
        },
        [main, setMessage, premiumOptions]
    );

    useEffect(() => {
        if (subject && message) {
            main.setSubject(subject);
            main.setMessage(message);
        }
    }, [main, subject, message]);

    return (
        <>
            <ToggleContainer className={css['email-title-position']} title={t('attendees.invitations.toggle')} onChange={handleToggle} checked={emailToggle} />
            {checked && (
                <div className={css['email-optional-section']}>
                    <div className={css['optional-inputs']}>
                        <InputLabel label={t('attendees.invitations.message.labels.subject')} />
                        <Input placeholder={t('attendees.invitations.message.subject')} onChange={handleObject} value={subject} />
                    </div>
                    <div className={css['optional-inputs']}>
                        <InputLabel label={t('attendees.invitations.message.labels.body')} />
                        {!messageIsValid && <Message title={t('attendees.invitations.premium_url_not_allowed')} type="danger" visible />}
                        <TextArea
                            className={`${css['email-textarea']} ${valid ? css['valid'] : css['invalid']}`}
                            onPaste={handleMessage}
                            onChange={handleMessage}
                            value={message}
                            placeholder={t('attendees.invitations.message.subject')}
                        />
                    </div>
                </div>
            )}
        </>
    );
});
export default EmailToggle;
